import { render, staticRenderFns } from "./document-subfolder.vue?vue&type=template&id=432035b4"
import script from "./document-subfolder.vue?vue&type=script&lang=js"
export * from "./document-subfolder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports